import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { type JsonLd } from '../models/json-ld';

@Injectable({
    providedIn: 'root',
})
export class JsonLdService {
    private readonly document = inject(DOCUMENT);
    private jsonLd!: JsonLd | JsonLd[];

    public setData(data: JsonLd | JsonLd[]): void {
        this.jsonLd = data;
        this.inject();
    }

    public getObject(type: string, rawData?: JsonLd, context = 'https://schema.org'): JsonLd {
        let object: JsonLd = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            '@type': type,
        };

        if (context) {
            object = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                '@context': context,
                ...object,
            };
        }

        if (rawData) {
            object = {
                ...object,
                ...rawData,
            };
        }

        return object;
    }

    private inject(): void {
        let ldJsonScriptTag = this.document.head.querySelector('script[type=\'application/ld+json\']');

        if (!ldJsonScriptTag) {
            ldJsonScriptTag = this.document.createElement('script');
            ldJsonScriptTag.setAttribute('type', 'application/ld+json');
            this.document.head.appendChild(ldJsonScriptTag);
        }

        ldJsonScriptTag.textContent = JSON.stringify(this.jsonLd);
    }

}
